module.exports = __webpack_public_path__ + "img/pix-qr-code.fd2315ae.png";